// extracted by mini-css-extract-plugin
export default {"list":"G1dxsNneGp","item":"fWxNo7CXEL"};